import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/jmi-logo-white.svg")